import React from "react";

import { Grid } from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import { useTheme } from "@mui/material";

const AddButton = ({
  onClick,
}: {
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
}) => {
  const theme = useTheme();
  return (
    <Grid
      id="uploadfileicon"
      sx={{
        px: 0.8,
        pt: 0.3,
        background: theme.palette.primary.main,
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "3px",
      }}
      onClick={onClick}
    >
      <AddIcon
        color="primary"
        sx={{
          fontSize: "14px",
          color: "#fff",
        }}
      />
    </Grid>
  );
};

export default AddButton;
